<template>
  <div class="o-notification">
    <SfNotification
      v-for="notification in notifications"
      :key="notification.id"
      class="notification"
      :visible="true"
      :type="getType(notification)"
      :message="notification.message"
    >
      <template #action>
        <button
          v-for="action in getActions(notification)"
          :key="action.label"
          class="sf-notification__action"
          @click="executeAction(action.action, notification.id)"
        >
          {{ action.label }}
        </button>
      </template>
      <template #close>
        <SfIcon
          class="sf-notification__close"
          icon="cross"
          color="white"
          @click="removeNotification(notification.id)"
        />
      </template>
    </SfNotification>
  </div>
</template>

<script>
import { Notification } from "@lib/modules/notification/components/Notification";

import { SfNotification, SfIcon } from "@lib/components";

export default {
  name: "Notification",
  mixins: [Notification],
  components: { SfNotification, SfIcon },
  methods: {
    getType({ type }) {
      return ["secondary", "info", "success", "warning", "danger"].includes(
        type
      )
        ? type
        : "danger";
    },
    getActions({ action1, action2 }) {
      return [action1, action2].filter(Boolean);
    },
    executeAction(action, id) {
      if (typeof action === "function") {
        action();
      }
      this.$store.dispatch("notification/removeNotificationById", id);
    },
    removeNotification(id) {
      this.$store.dispatch("notification/removeNotificationById", id);
    },
  },
};
</script>

<style lang="scss">
@use "~@lib/styles/helpers/breakpoints" as *;

.o-notification {
  position: fixed;
  top: 100px;
  right: 5%;
  z-index: 1000;
  @include for-mobile {
    top: 0;
    left: 0;
    right: unset;
  }
  @include for-desktop {
    display: flex;
    flex-direction: column;
  }

  .notification {
    &:not(:first-child) {
      margin-top: 1rem;
    }
    .sf-notification__action {
      cursor: pointer;
      margin: 0.3rem 1rem 0 0;
    }

    .sf-notification__message {
      padding-right: 2rem;
    }
    @include for-desktop {
      max-width: 32rem;
      align-self: end;
      .sf-notification__close {
        position: relative;
        margin-left: var(--spacer-lg);
      }
    }
  }
}
</style>
